export const portraitBackgroundImageData = {
  videoFileName:
    'https://mediaorigin.nrk.no/movingstill/dbc384e0-aca2-46f6-8384-e0aca276f624/20230117134733/dbc384e0-aca2-46f6-8384-e0aca276f624_720.mp4',
  stillFileName:
    'https://mediaorigin.nrk.no/movingstill/dbc384e0-aca2-46f6-8384-e0aca276f624/20230117134733/dbc384e0-aca2-46f6-8384-e0aca276f624_720.jpg',
  profile: '1280x720',
  name: 'portrait',
  height: 720,
  displayAspectRatio: '9:16',
};
export const landscapeBackgroundImageData = {
  videoFileName:
    'https://mediaorigin.nrk.no/movingstill/8f567438-2167-41b3-9674-38216711b36d/20230109140332/8f567438-2167-41b3-9674-38216711b36d_1080.mp4',
  stillFileName:
    'https://mediaorigin.nrk.no/movingstill/8f567438-2167-41b3-9674-38216711b36d/20230109140332/8f567438-2167-41b3-9674-38216711b36d_1080.jpg',
  profile: '1920x1080',
  name: 'landscape',
  height: 1080,
  displayAspectRatio: '16:9',
};
